var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_283",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0985 57.3498C70.1495 59.4284 49.694 67.915 45.3389 70.2054C40.9838 72.4958 38.5649 72.474 35.1239 70.8151C31.683 69.1562 9.91513 60.2836 5.99158 58.3911C4.0298 57.4448 3.00183 56.649 3.00183 55.8967V48.3485C3.00183 48.3485 31.3436 42.1226 35.9204 40.4656C40.4972 38.8087 42.0804 38.7493 45.9765 40.1885C49.8726 41.6277 73.153 45.866 77 47.2894V54.7327C77 55.479 76.1133 56.3164 74.1024 57.3537L74.0985 57.3498Z",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0986 49.8003C70.1495 51.8789 49.6941 60.3655 45.3389 62.6559C40.9838 64.9463 38.5649 64.9245 35.124 63.2656C31.683 61.6067 9.91516 52.7341 5.99161 50.8415C2.06806 48.949 1.98958 47.6484 5.84055 46.1261L35.9185 34.3751C40.4933 32.7201 42.0785 32.6588 45.9746 34.098C49.8706 35.5371 70.2025 43.703 74.0475 45.1482C77.8926 46.5933 78.0437 47.7415 74.0946 49.8201L74.0986 49.8003Z",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0985 45.0412C70.1495 47.1198 49.694 55.6064 45.3389 57.8968C40.9838 60.1872 38.5649 60.1654 35.1239 58.5065C31.683 56.8476 9.91513 47.975 5.99158 46.0825C4.0298 45.1362 3.00183 44.3404 3.00183 43.5881V36.0399C3.00183 36.0399 31.3436 29.814 35.9204 28.1571C40.4972 26.5001 42.0804 26.4407 45.9765 27.8799C49.8726 29.3191 73.153 33.5574 77 34.9808V42.4241C77 43.1705 76.1133 44.0078 74.1024 45.0451L74.0985 45.0412Z",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0985 37.4928C70.1495 39.5714 49.6941 48.058 45.3389 50.3484C40.9838 52.6389 38.5649 52.6171 35.124 50.9582C31.683 49.2992 9.91516 40.4266 5.99161 38.5341C2.06806 36.6416 1.98958 35.341 5.84055 33.8187L35.9185 22.0696C40.4933 20.4127 42.0785 20.3533 45.9745 21.7925C49.8706 23.2317 70.2025 31.3996 74.0515 32.819C77.9005 34.2383 78.0476 35.4123 74.0985 37.4908V37.4928Z",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0985 32.2766C70.1495 34.3552 49.694 42.8418 45.3389 45.1342C40.9838 47.4265 38.5649 47.4028 35.1239 45.7439C31.683 44.085 9.91513 35.2123 5.99158 33.3198C4.0298 32.3736 3.00183 31.5778 3.00183 30.8255V23.2733C3.00183 23.2733 31.3436 17.0474 35.9204 15.3905C40.4972 13.7335 42.0804 13.6741 45.9765 15.1133C49.8726 16.5525 73.153 20.7908 77 22.2142V29.6575C77 30.4038 76.1133 31.2412 74.1024 32.2785L74.0985 32.2766Z",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0985 24.7262C70.1495 26.8048 49.6941 35.2914 45.3389 37.5818C40.9838 39.8723 38.5649 39.8505 35.124 38.1916C31.683 36.5326 9.91516 27.66 5.99161 25.7675C2.06806 23.875 1.98958 22.5744 5.84055 21.0521L35.9185 9.30305C40.4933 7.64611 42.0785 7.58672 45.9745 9.0259C49.8706 10.4651 70.2025 18.633 74.0515 20.0524C77.9005 21.4717 78.0476 22.6457 74.0985 24.7242V24.7262Z",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8469 21.6142L39.5281 17.7242L32.1244 17.0511L37.6487 15.0399L35.991 11.9517L41.1623 13.9907L46.0393 12.3793L44.7209 15.5704L49.6921 17.451L43.281 18.1241L41.8469 21.6142ZM29.4956 29.3584L46.6415 26.7018L41.4624 34.3668L29.4956 29.3584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8737 26.5652C29.9356 26.5652 34.0391 24.9601 34.0391 22.9801C34.0391 21.0001 29.9356 19.395 24.8737 19.395C19.8117 19.395 15.7083 21.0001 15.7083 22.9801C15.7083 24.9601 19.8117 26.5652 24.8737 26.5652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4206 22.4575L57.2782 26.4999L57.2704 18.4092L67.4206 22.4575Z",
    fill: "#7A0C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2802 26.5003L56.1816 26.9358L46.0471 22.8935L57.2744 18.4116L57.2802 26.5003Z",
    fill: "#AD2115"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/redis.4586a9f0b2ae7d22244c3e1f01b6fd9d.svg";
export { ForwardRef as ReactComponent };